import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'md-tabs-bg',
  templateUrl: 'tabs-bg.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsBgComponent {}
